// extracted by mini-css-extract-plugin
export default {"header":"style_header__mroM5","title":"style_title__7hYk2","deleteButton":"style_deleteButton__cFeEN"};